import styled from 'styled-components';
import { semanticTheme } from '@tools/ui/dime';

export const RISK_BADGE_TONE_COLOR: Record<string, string> = {
  critical: semanticTheme.dime.colors.fill.criticalPrimary,
  success: semanticTheme.dime.colors.fill.successPrimary,
  warning: semanticTheme.dime.colors.fill.warningPrimary
};

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${semanticTheme.dime.spacing.m};
  min-height: ${semanticTheme.dime.fonts.lineHeights.md};
`;

export const RiskScoreBadge = styled.div<{ bgColor: string; color?: string }>`
  background: ${({ bgColor }) => bgColor};
  color: ${({ color }) => color ?? 'white'};
  font-size: ${semanticTheme.dime.fonts.sizes.xs};
  line-height: 1;
  border-radius: 100px;
  padding: 0 6px;
  height: ${semanticTheme.dime.spacing.l};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ShowMoreButton = styled.div`
  display: flex;
  align-items: center;
  gap: ${semanticTheme.dime.spacing.m};
  cursor: pointer;
`;

export const LinkAnchor = styled.a`
  display: inline-flex;
  align-items: center;
  gap: ${semanticTheme.dime.spacing.s};
  color: ${semanticTheme.dime.colors.link.primary};

  &:hover {
    color: ${semanticTheme.dime.colors.link.primary};
    text-decoration: underline;
  }
`;
